<template>
	<div class="page">
		<!-- your page -->
		<Head></Head>
		<div class="detail">
			<div class="fixation">
				<div class="title">
					订单信息
				</div>
				<div class="detailBox">
					<div class="address">
						<div class="leftTitle">
							收货地址
						</div>
						<div class="addressInfo">
							<div class="person">
								<span>{{info.address.name}}</span><span>{{info.address.phone}}</span><span>{{info.address.address}}</span>
							</div>
							<div class="email">
								{{info.address.email}}
							</div>
						</div>
					</div>
					<div class="logistics">
						<div class="leftTitle">
							物流信息
						</div>
						<div class="logisticsInfo">
							<div class="line" v-for="(item,index) in info['delivery']" :key="index">物流公司:{{item.logi_name}} 物流单号:{{item.logi_no}}</div>
							<div class="line">
								{{info.logistics.time}} <span>······</span> {{info.logistics.context}}
							</div>
							<div class="line" v-if="info['delivery'].length==0">
								暂时没有物流信息
							</div>
						</div>
					</div>
					<div class="remark">
						<div class="leftTitle">
							买家留言
						</div>
						<div class="remarkInfo">
							{{info.remark}}
							<span v-if="info.remark.length==0">买家没有留下留言</span>
						</div>
					</div>
					<div class="product">
						<div class="table">
							<div class="tHead">
								<div class="information">
									产品
								</div>
								<div class="uPrice">
									单价
								</div>
								<div class="uNumber">
									数量
								</div>
								<div class="uCost">
									运费
								</div>
								<div class="uAllPrice">
									价格合计
								</div>
							</div>
							<div class="tBody">
								<div class="left">
									<div class="unit" v-for="(item,index) in info['information']" :key="index">
										<div class="avatar">
											<img :src="item.image_url" alt="">
										</div>
										<div class="proInfo">
											<div class="proName">
												{{item.name}}
											</div>
											<div class="proTab">
												{{item.bn}}
											</div>
										</div>
										<div class="unitPrice">
											¥{{item.price}}
										</div>
										<div class="number">
											{{item.nums}}
										</div>
									</div>
								</div>
								<div class="right" :style="'height:'+info['information'].length*90+'px'">
									<div class="cost">
										<div class="costIn">
											¥{{info.cost}}
										</div>
									</div>
									<div class="allPrice">
										<div class="priceIn">
											¥{{info.allPrice}}
										</div>
									</div>
								</div>
								<div class="clear"></div>
							</div>
							<div class="tFoot">
								<div class="operation">
									<span>价格合计:&nbsp;&nbsp;</span>¥{{info.allPrice}}
								</div>
							</div>
						</div>
						<div class="buttonGroup">
							<button @click="refund">申请退款</button>
							<button @click="evaluate">去评价</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	//your script
	import Head from '../../components/head.vue'
	import Foot from '../../components/foot.vue'
	export default {
		name: 'detail',
		components:{
			Head,Foot
		},
		data(){
			return {
				info:{
					address:{
						name:"",
						phone:"",
						address:"",
						email:""
					},
					delivery:[],
					logistics:{},
					remark:"",
					information:"",
					cost:"",
					allPrice:""
				}
			}
		},
		methods:{
			refund(){
				this.$router.push({path:"/refund",query:{oid:this.oid}})
			},
			evaluate(){
				this.$router.push({path:"/evaluate",query:{oid:this.oid}})
			},
			fetchData(){
				var data = {
					method:"order.details",
					order_id:this.oid,
					token:this.token
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						that.info = {
							address:{
								name:res.data.ship_name,
								phone:res.data.ship_mobile,
								address:res.data.ship_area_name+' '+res.data.ship_address,
								email:res.data.mail
							},
							delivery:res.data.delivery,
							logistics:res.data.express_delivery,
							remark:res.data.memo,
							information:res.data.items,
							cost:res.data.cost_freight,
							allPrice:res.data.order_amount
						}
					}else{
						
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.oid = this.$route.query.oid
			this.status = this.$route.query.status
			this.token = localStorage.getItem('token')
			if(this.status!=6){
				this.fetchData()
			}else{
				this.fetchAfterSale()
			}
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.detail{
		width: 100%;
	}
	.title{
		width: 100%;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		font-weight: 600;
	}
	.detailBox{
		width: 100%;
		border: 1px solid #C3C3C3;
		padding: 30px 20px 15px 20px;
		box-sizing: border-box;
	}
	.address,.logistics,.remark,.product{
		width: 100%;
		position: relative;
		border-bottom: 1px solid #E3E3E3;
		padding: 10px 0px;
		box-sizing: border-box;
	}
	.leftTitle{
		width: 120px;
		height: 70px;
		font-size: 16px;
		font-weight: 600;
		position: absolute;
		left: 0px;
		top: 10px;
		line-height: 30px;
	}
	.addressInfo,.logisticsInfo,.remarkInfo{
		width: 100%;
		padding-left: 120px;
		box-sizing: border-box;
	}
	.logisticsInfo,.remarkInfo{
		min-height: 70px;
	}
	.person{
		width: 100%;
		min-height: 30px;
		line-height: 30px;
		font-size: 0px;
		letter-spacing: -6px;
	}
	.person span{
		display: inline-block;
		vertical-align: top;
		font-size: 14px;
		letter-spacing: normal;
		margin-left: 10px;
	}
	.person span:nth-child(1){
		margin-left: 0px;
	}
	.email{
		width: 100%;
		height: 30px;
		line-height: 30px;
	}
	.logisticsInfo .line{
		width: 100%;
		height: 30px;
		line-height: 30px;
	}
	.logisticsInfo .line span{
		color: #838383;
	}
	.remarkInfo{
		line-height: 30px;
		padding-right: 100px;
		box-sizing: border-box;
	}
	.table{
		width: 100%;
		border: 1px solid #C3C3C3;
		box-sizing: border-box;
	}
	.tHead{
		width: 100%;
		height: 30px;
		line-height: 30px;
		background: #F0F0F0;
		border-bottom: 1px solid #C3C3C3;
	}
	.information,.uPrice,.uNumber,.uCost,.uAllPrice{
		height: 100%;
		float: left;
		text-align: center;
	}
	.information{
		width: 488px;
	}
	.uPrice{
		width: 167px;
	}
	.uNumber{
		width: 167px;
	}
	.uCost{
		width: 167px;
	}
	.uAllPrice{
		width: 167px;
	}
	.tBody{
		width: 100%;
	}
	.left,.right{
		height: 100%;
		float: left;
	}
	.left{
		width: 822px;
		border-right: 1px solid #C3C3C3;
		box-sizing: border-box;
	}
	.right{
		width: 334px;
		border-bottom: 1px solid #C3C3C3;
	}
	.unit{
		width: 100%;
		height: 90px;
		border-bottom: 1px solid #C3C3C3;
	}
	.avatar{
		width: 90px;
		height: 100%;
		float: left;
	}
	.avatar img{
		width: 80px;
		height: 80px;
		display: block;
		margin: 5px auto;
	}
	.proInfo{
		width: 398px;
		float: left;
		height: 100%;
		border-right: 1px solid #C3C3C3;
		box-sizing: border-box;
	}
	.proName,.proTab{
		width: 100%;
	}
	.proName{
		height: 50px;
		line-height: 25px;
		color: #333333;
	}
	.proTab{
		height: 40px;
		line-height: 40px;
		color: #838383;
	}
	.unitPrice,.number{
		width: 167px;
		height: 100%;
		float: left;
		text-align: center;
		line-height: 90px;
	}
	.unitPrice{
		border-right: 1px solid #C3C3C3;
		box-sizing: border-box;
		color: red;
	}
	.number{
		width: 166px;
		border-right: none;
	}
	.cost,.allPrice{
		position: relative;
		float: left;
		height: 100%;
	}
	.cost{
		width: 167px;
		border-right: 1px solid #C3C3C3;
	}
	.allPrice{
		width: 166px;
		color: red;
	}
	.costIn,.priceIn{
		width: 100%;
		position: absolute;
		height: 40px;
		left: 0px;
		top: 50%;
		margin-top: -20px;
		text-align: center;
		line-height: 40px;
	}
	.tFoot{
		width: 100%;
		height: 40px;
	}
	.tFoot .operation{
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding-right: 20px;
		box-sizing: border-box;
		font-size: 16px;
		color: red;
	}
	.tFoot .operation span{
		font-size: 14px;
		color: #333333;
	}
	.buttonGroup{
		width: 100%;
		height: 60px;
		padding: 10px 0px;
		box-sizing:border-box;
		display: flex;
		justify-content: flex-end;
	}
	button{
		width: 100px;
		height: 100%;
		border: none;
		background: none;
		cursor: pointer;
		background: #197AFF;
		color: #FFFFFF;
		margin-right: 20px;
	}
	button:last-child{
		margin-right: 0px;
	}
	button:hover{
		border: 1px solid #197AFF;
		color: #197AFF;
		box-sizing: border-box;
		background: none;
	}
	.clear{
		clear: both;
	}
</style>
